import api from '@/lib/api';

export interface SoDuTonKhoItem {
  ma_vt: string;
  dvt?: string | null;
  ma_kho?: string | null;
}

export interface SoDuTonKhoResponse {
  ngay_ct: string;
  results: {
    ma_kho: string | null;
    ma_vt: string;
    dvt: string;
    so_du: string;
  }[];
}

export const fetchSoDuTonKho = async (
  entitySlug: string,
  ngay_ct: string,
  items: SoDuTonKhoItem[]
): Promise<SoDuTonKhoResponse> => {
  if (!entitySlug || !ngay_ct || !items.length) {
    return { ngay_ct, results: [] };
  }
  const cleanedItems = items.map(item => {
    const cleanItem = { ...item };
    if (!cleanItem.dvt) {
      delete cleanItem.dvt;
    }
    if (!cleanItem.ma_kho) {
      delete cleanItem.ma_kho;
    }
    return cleanItem;
  });

  const { data } = await api.post(`/entities/${entitySlug}/erp/ton-kho/so-kho/so-du-ton-kho/`, {
    ngay_ct,
    items: cleanedItems
  });
  return data;
};
